<script>
  import Poster from "@components/Poster";
  import Transcript from "@components/Transcript";
  import Videos from "@components/Videos";
  import { activeVideo, introSeen, maximized } from "@stores/global";
  import { supportsEnhancedExperience } from "@utils/support";
  import { VIDEOS } from "../consts";

  export let conversation;
  export let dwell;
  export let poster;
  export let title;
  export let transcript;

  $: showPoster = poster &&
                  supportsEnhancedExperience &&
                  (!$maximized || (!$introSeen && $activeVideo === VIDEOS.DWELL));
</script>

{#if showPoster}
  <Poster alt={title} src={poster} />
{/if}

<Videos {conversation} {dwell}>
  <Transcript {transcript} />
</Videos>
